// Routes rendered by application components rather than the CMS catch-all.
const appPaths = new Set([
  "/", "/membership", "/membership/apply", "/membership/map", "/about/news",
  "/resources/trauma-faqs", "/prevention/injury-prevention-tips",
  "/resources/injury-prevention-tips", "/education/webinars",
  "/education/regional-conferences", "/members/networking", "/members/mentors",
  "/events", "/directory", "/search", "/sitemap", "/auth/login", "/auth/register",
  "/forgot-password", "/reset-password",
]);

export const cmsSlugAliases: Record<string, string> = {
  "advocacy-outreach-committee": "about-committees-advocacy-outreach-committee",
  "advocacy-committee": "about-committees-advocacy-outreach-committee",
  "education-committee": "about-committees-education-committee",
  "injury-prevention-committee": "about-committees-injury-prevention-committee",
  "pediatric-committee": "about-committees-pediatric-committee",
  "performance-improvement-committee": "about-committees-performance-improvement-committee",
  "regisrar-committee": "about-committees-registrar-committee",
  "registrar-committee": "about-committees-registrar-committee",
  "research-committee": "about-committees-research-committee",
  "rural-committee": "about-committees-rural-committee",
};

export function normalizePagePath(path: string): string {
  return path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
}

export function isCmsPath(path: string): boolean {
  path = normalizePagePath(path);
  if (appPaths.has(path) || /^\/(?:admin|member)(?:\/|$)/.test(path)) return false;
  if (/^\/events\/[^/]+$/.test(path) ||
      /^\/education\/webinars\/[^/]+$/.test(path) ||
      /^\/(?:about\/news|(?:prevention|resources)\/injury-prevention-tips)\/[^/]+$/.test(path)) return false;
  return true;
}

export function pathToCmsSlug(path: string): string {
  return decodeURIComponent(normalizePagePath(path)).replace(/^\/+|\/+$/g, "").replace(/\//g, "-");
}

type Page = { slug: string; isPublished?: boolean | null };

export function isPublicLinkValid(url: string, pages: readonly Page[], origin: string): boolean {
  if (!url.trim() || url.startsWith("#")) return true;
  try {
    const target = new URL(url, origin);
    if (["mailto:", "tel:"].includes(target.protocol)) return true;
    if (!["http:", "https:"].includes(target.protocol)) return false;
    if (target.origin !== new URL(origin).origin) return true;
    if (/^\/(?:docs|objects|api)(?:\/|$)/.test(target.pathname) ||
        /\.(?:pdf|docx?|xlsx?|pptx?|png|jpe?g|webp|gif|zip|mp4|mp3)$/i.test(target.pathname)) return true;
    if (!isCmsPath(target.pathname)) return true;
    const slug = pathToCmsSlug(target.pathname);
    // Match API resolution: an unpublished exact match must not fall back.
    const page = pages.find(p => p.slug === slug) ??
      pages.find(p => p.slug === cmsSlugAliases[slug]);
    return !!page && page.isPublished !== false && page.isPublished !== null;
  } catch {
    return false;
  }
}